import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDgL0L9Yxx27IBQQcu5Rxwc5ijkKyM9bCY",
  authDomain: "dummybackend-f663b.firebaseapp.com",
  projectId: "dummybackend-f663b",
  storageBucket: "dummybackend-f663b.appspot.com",
  messagingSenderId: "102518242670",
  appId: "1:102518242670:android:81ff49ae00f32261f4957f"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
